import { cn } from '@/lib/utils'

import type { BadgeGlyphId } from '@scrambl/shared'
import { BADGE_GLYPHS } from '@scrambl/shared'

/** A badge glyph as a plain monochrome line icon (menus, buttons). */
export function BadgeLineIcon({
  glyph,
  className,
}: {
  glyph: BadgeGlyphId
  className?: string
}) {
  const geometry = BADGE_GLYPHS[glyph]
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={cn('h-4 w-4', className)}
    >
      {geometry.paths.map(d => (
        <path key={d} d={d} />
      ))}
      {geometry.circles?.map(([cx, cy, r]) => (
        <circle key={`c${cx}-${cy}-${r}`} cx={cx} cy={cy} r={r} />
      ))}
      {geometry.dots?.map(([cx, cy, r]) => (
        <circle
          key={`d${cx}-${cy}-${r}`}
          cx={cx}
          cy={cy}
          r={r}
          fill="currentColor"
          stroke="none"
        />
      ))}
    </svg>
  )
}

export function AchievementsIcon({ className }: { className?: string }) {
  return <BadgeLineIcon glyph="trophy" className={className} />
}
